import { PageContainer } from "@/components/layout/PageContainer";
import { OverviewHero } from "./OverviewHero";
import { WhatIsSection } from "./WhatIsSection";
import { RolesSection } from "./RolesSection";
import { ModulesSection } from "./ModulesSection";
import { GettingStartedSection } from "./GettingStartedSection";
import { QuickAnswersSection } from "./QuickAnswersSection";
import { NeedMoreHelpSection } from "./NeedMoreHelpSection";

export function DocumentationOverview() {
  return (
    <PageContainer width="wide" className="pb-16">
      <OverviewHero />
      <WhatIsSection />
      <RolesSection />
      <ModulesSection />
      <GettingStartedSection />
      <QuickAnswersSection />
      <NeedMoreHelpSection />
    </PageContainer>
  );
}
